export default __webpack_public_path__ + "static/media/collapseToggleIcon.2b2f6356.svg";